import {useQuery} from '@tanstack/react-query';
import {useAuth} from '@/contexts/AuthContext';
import {ReitService as reitService} from '@/services/investments';

/**
 * Custom hook to retrieve REIT dividend payment data for a specific holding.
 *
 * @param {string} [holdingId] - The optional identifier of the holding to filter the dividend payments.
 * @return {object} The query object returned by the `useQuery` function, which includes the status, data, error, and more.
 */
export default function useFetchReitDividendPayments(holdingId?: string) {
  const { user } = useAuth();
  return useQuery({
    queryKey: ['reit_dividend_payments', user?.id, holdingId],
    queryFn: async () => {
      return await reitService.getDividendPayments(user!.id, holdingId)
    },
    enabled: !!user,
  });
}
